const config = window.APP_CONFIG;

const emailTemplatesFR = [
  {
    id: 0,
    language: "fr",
    subject: "Réponse rapide",
    body: `<p>Bonjour {{nickname}}</p>
<p>Je suis actuellement en réunion et j’ai besoin que tu effectues rapidement une tâche pour moi. Envoie-moi ton numéro WhatsApp et attends mon message.</p>
<p class="pt-4">Bien à toi,</p><p>${config.CEO}</p>`,
    sender: `<p class="malicious" title="Ceci semble être une adresse Gmail personnelle. Le compte a probablement été compromis et le nom a été modifié pour se faire passer pour votre PDG">${config.CEO} &lt;alainhenrard76@gmail.com&gt;</p>`,
    isPhishing: true,
    footer: ``
  },

  {
    id: 1,
    language: "fr",
    subject: "Activité de connexion inhabituelle détectée",
    body: `
  <div style="text-align:center;">
    <img src="/images/microsoft.png" alt="Logo Microsoft" style="display:block; margin: 0 auto; height: 150px;" />
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
      Nous avons détecté une tentative de connexion à votre compte Microsoft depuis un nouvel appareil ou une nouvelle localisation.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Nous vous recommandons de vérifier immédiatement les paramètres de votre compte.
    </p>
    <div style="margin: 24px 0;">
      <a
        href="https://micr0s0ft.com/login"
        class="malicious"
        title="Attention : domaine suspect"
        style="background:#dc3545;color:white;padding:12px 20px;border-radius:4px;font-weight:bold;"
      >
        Vérifier l’activité
      </a>
    </div>
    <p style="font-size:13px; color:#666;">Activité détectée : 05 juin 2025 à 10:42 (CET)</p>
  </div>`,
    sender: `<p class="malicious" title="Expéditeur suspect avec domaine ressemblant">Microsoft Sécurité &lt;security@micr0s0ft.com&gt;</p>`,
    isPhishing: true,
    footer: `
  <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
    Cet e-mail a été généré automatiquement. Ne répondez pas directement.<br />
    Consultez vos <a href="https://account.microsoft.com/security" style="color:#dc3545; text-decoration:underline;">paramètres de sécurité</a> pour plus d’informations.
  </div>`
  },

  {
    id: 4,
    language: "fr",
    subject: "Mise à jour de sécurité importante – à effectuer aujourd’hui",
    body: `
  <div style="text-align:center;">
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">Bonjour {{nickname}},</p>
    <p class="pb-4" style="font-size:15px; line-height:1.6; color:#333;">
      Une mise à jour de sécurité importante est disponible pour votre poste de travail. Afin de réduire les risques, merci de l’installer aujourd’hui.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Cliquez sur le bouton ci-dessous pour lancer la mise à jour immédiatement.
    </p>
    <div style="margin: 24px 0;">
      <a
        href="https://${config.companyDomainPhishing}/update"
        class="malicious"
        title="Le domaine ne correspond pas à votre organisation"
        style="background:#ffc107; color:black; padding:12px 20px; border-radius:4px; font-weight:bold;"
      >
        Démarrer la mise à jour
      </a>
    </div>
    <p style="font-size:13px; color:#666;">
      ID de mise à jour : KB509821 — disponible depuis ${new Date().toLocaleDateString('fr-FR')}
    </p>
  </div>`,
    sender: `<p class="malicious" title="Le domaine de l’expéditeur diffère de celui de la gestion informatique interne">Admin IT &lt;it@${config.companyDomainPhishing}&gt;</p>`,
    isPhishing: true,
    footer: `
  <div style="font-size:12px; color:#888; padding-top:10px; text-align:center;">
    Des questions ? Contactez <a href="mailto:it@${config.companyDomainPhishing}" style="text-decoration:underline;color:#ffc107;">it@${config.companyDomainPhishing}</a><br />
    Ce message a été envoyé automatiquement par le système de gestion IT.
  </div>`
  },

  {
    id: 5,
    language: "fr",
    subject: "Quelqu’un a répondu à votre publication",
    body: `<div style="text-align:center;">
    <img src="/images/linkedin.png" alt="LinkedIn" style="display:block;margin:0 auto;height:200px;" />
    <p style="font-size:15px; line-height:1.6;">Quelqu’un vient de commenter l’une de vos publications récentes.</p>
    <p style="font-size:15px; line-height:1.6;">Consultez la réponse et rejoignez la conversation.</p>
    <div class="relative group" style="margin: 20px 0; display: inline-block;">
      <a
        href="https://www.Iinkedin/activity/post/8394"
        class="malicious"
        style="background:#0077b5; color:white; padding:10px 20px; border-radius:4px; display:inline-block; font-weight:bold;"
      >
        Voir l’activité
      </a>
      <div
        class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
      >
        Avertissement : l’expéditeur semble être linkedin.com mais c’est en réalité Iinkedin.com.<br />Vous pouvez le repérer en survolant le bouton.
      </div>
    </div>
  </div>`,
    sender: `
  <span class="relative group inline-block">
    <span style="font-family: monospace;" class="malicious">
      Notifications LinkedIn &lt;noreply@Iinkedin.com&gt;
    </span>
    <div
      class="hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 bg-black text-white text-xs font-mono px-3 py-2 rounded shadow-lg z-50 max-w-xs text-center"
    >
      L’expéditeur semble être linkedin.com mais c’est en réalité Iinkedin.com.<br />
      Vous pouvez le repérer en survolant le domaine.
    </div>
  </span>`,
    isPhishing: true,
    footer: `<div style="font-size:12px;color:#888;padding-top:10px;text-align:center;">
    Vous recevez cette notification en fonction de vos paramètres.<br />
    <a href="https://www.Iinkedin.com/settings/" style="color:#0077b5;text-decoration:underline;">Gérer mes paramètres</a>
  </div>`
  },

  {
    id: 7,
    language: "fr",
    subject: "Vous avez un nouveau commentaire sur votre publication",
    body: `
  <div style="text-align:center;">
    <img src="/images/fb.svg" alt="Logo Facebook" style="display:block; margin: 0 auto 16px; height:40px;" />
    <p style="font-size:15px; color:#333; line-height:1.6;">
      Quelqu’un a commenté l’une de vos publications Facebook récentes.
    </p>
    <p style="font-size:15px; color:#333; line-height:1.6;">
      Consultez le commentaire et restez informé.
    </p>
    <div style="margin: 20px 0;">
      <div class="relative inline-block group mt-4">
        <a
          href="https://facebook-alerts.com/meldingen"
          class="malicious"
          title="Ce bouton mène vers une URL Facebook non officielle"
          style="background:#1877f2; color:white; padding:12px 20px; border-radius:4px; font-weight:bold; display:inline-block;"
        >
          Voir votre notification
        </a>
        <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-full bg-red-600 rounded"></div>
      </div>
    </div>
  </div>`,
    sender: `<p class="malicious" title="Adresse d’expéditeur usurpée ; ce n’est pas un domaine Facebook valide">Notifications Facebook &lt;no-reply@facebook-alerts.com&gt;</p>`,
    isPhishing: true,
    footer: `
  <div style="font-size:12px; color:#888;padding-top:10px; text-align:center;">
    Cette notification a été envoyée selon vos paramètres de compte.<br />
    Facebook ne demande jamais d’informations personnelles par e-mail.<br />
    <p href="https://facebook-alerts.com/meldingen" class="malicious" title="URL Facebook non officielle">Voir votre notification</p>
  </div>`
  },

  {
    id: 9,
    language: "fr",
    subject: "Votre facture Eneco de ce mois est disponible",
    body: `
  <div style="text-align:center;">
    <img src="/images/Eneco.png" alt="Logo Eneco" style="display:block; margin: 0 auto; height: 150px;" />
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Votre nouvelle facture d’énergie est disponible dans votre portail client.
    </p>
    <p style="font-size:15px; line-height:1.6; color:#333;">
      Vous pouvez la payer rapidement et en toute sécurité via le code QR ci-dessous.
    </p>
    <div style="margin: 24px 0;" class="group relative inline-block">
      <img
        src="https://api.qrserver.com/v1/create-qr-code/?data=https://eneco-facturatie.be&size=150x150"
        class="malicious"
        title="Le code QR mène vers un domaine qui n’est pas officiellement celui d’Eneco"
        style="display:block; margin: 0 auto;"
      />
      <div class="absolute left-1/2 transform -translate-x-1/2 mt-1 h-[2px] w-[150px] bg-red-600 rounded"></div>
    </div>
    <p style="font-size:13px; color:#666;">Numéro de facture : ENE-202406-8127</p>
  </div>`,
    sender: `<p class="malicious" title="Ce domaine n’est pas un domaine officiel d’Eneco">Eneco Belgique &lt;factures@eneco-facturatie.be&gt;</p>`,
    isPhishing: true,
    footer: ``
  }
];

export default emailTemplatesFR;
